import { apiGet } from "./apiClient";
import { AiCharacter, AiMatchAnalysis, AiLeagueDaySummary } from "../types/Ai";

// AI Features endpoints (see Analysis/AnalysisProvider/Controllers/AiFeaturesController).
// ASP.NET routing is case-insensitive, so the controller's "api/AiFeatures" resolves fine.

/** The 6 seeded pundit personas (always available). */
export function getAiCharacters(): Promise<AiCharacter[]> {
  return apiGet<AiCharacter[]>("/api/AiFeatures/characters");
}

/** Every persona's commentary for a match (empty until generated for that match). */
export function getMatchAnalyses(matchId: number): Promise<AiMatchAnalysis[]> {
  return apiGet<AiMatchAnalysis[]>(`/api/AiFeatures/match/${matchId}/analyses`);
}

/** Every stored daily recap for a league (empty until generated for a match day). */
export function getLeagueDaySummaries(
  leagueId: number
): Promise<AiLeagueDaySummary[]> {
  return apiGet<AiLeagueDaySummary[]>(
    `/api/AiFeatures/league/${leagueId}/day-summaries`
  );
}
